import React from 'react';
import _sharedStylesRaw from './ClubShared.module.css';
const sharedStyles = (typeof _sharedStylesRaw === 'object' && _sharedStylesRaw !== null) ? _sharedStylesRaw : {};
import styles from './ClubSquadStats.module.css';

export default function ClubSquadStats({ players }) {
    if (!players || players.length === 0) return null;

    const formatNumber = (num) => {
        if (num === undefined || num === null) return '0';
        return Math.round(num).toLocaleString('en-US');
    };

    const formatXg = (xg) => {
        if (xg === undefined || xg === null) return '0';
        // Round to nearest integer if requested, or keep 1 decimal if float
        return Math.round(xg).toString();
    };

    const cleanPosition = (pos) => {
        if (!pos) return 'Athlete';
        const p = pos.toLowerCase();
        if (p.includes('attacker') || p.includes('forward')) return 'Forward';
        if (p.includes('midfielder')) return 'Midfielder';
        if (p.includes('defender')) return 'Defender';
        if (p.includes('goalkeeper')) return 'Goalkeeper';
        return pos;
    };

    return (
        <section className={styles.squadSection}>
            <h2 className={sharedStyles.sectionTitle}>Squad Statistics</h2>
            <div className={styles.tableContainer}>
                <div className={styles.tableHeader}>
                    <span>Name</span>
                    <span>
                        <span className="desktop-only-label">Position</span>
                        <span className="mobile-only-label">Pos</span>
                    </span>
                    <span>
                        <span className="desktop-only-label">Minutes Played</span>
                        <span className="mobile-only-label">Min</span>
                    </span>
                    <span>
                        <span className="desktop-only-label">Actual Goals</span>
                        <span className="mobile-only-label">AG</span>
                    </span>
                    <span>
                        <span className="desktop-only-label">Expected Goals</span>
                        <span className="mobile-only-label">xG</span>
                    </span>
                    <span>
                        <span className="desktop-only-label">Assists</span>
                        <span className="mobile-only-label">A</span>
                    </span>
                </div>
                <div className={styles.scrollWrapper}>
                    <div className={styles.tableBody}>
                        {players.map((player) => (
                            <div key={player.id} className={styles.tableRow}>
                                <span className={styles.playerName}>{player.name}</span>
                                <span className={styles.playerPosition}>{cleanPosition(player.position)}</span>
                                <span className={styles.statValue}>{formatNumber(player.minutesPlayed)}</span>
                                <span className={styles.statValue}>{formatNumber(player.goals)}</span>
                                <span className={styles.statValue}>{formatXg(player.xg)}</span>
                                <span className={styles.statValue}>{formatNumber(player.assists)}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
